import { Controller } from "@hotwired/stimulus"
import { showToast } from "./toast"

export default class extends Controller {
  static targets = ["input", "button", "buttonText", "title", "subtitle", "isbn10", "isbn13",
                    "publisher", "publicationDate", "pageCount", "language", "description",
                    "coverImageUrl", "coverThumbnailUrl"]

  async lookup() {
    const isbn = this.inputTarget.value.trim()
    if (!isbn) {
      showToast("Please enter an ISBN")
      return
    }

    this.buttonTarget.disabled = true
    this.buttonTextTarget.textContent = "Looking up..."

    try {
      const response = await fetch("/app/books/import_isbn", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ isbn })
      })

      const data = await response.json()

      if (response.ok) {
        this.fillForm(data)
      } else {
        showToast(data.error || "Book not found")
      }
    } catch (error) {
      showToast("An error occurred while looking up the ISBN")
      console.error(error)
    } finally {
      this.buttonTarget.disabled = false
      this.buttonTextTarget.textContent = "Look Up"
    }
  }

  fillForm(data) {
    if (this.hasTitleTarget && data.title) {
      this.titleTarget.value = data.title
    }
    if (this.hasSubtitleTarget && data.subtitle) {
      this.subtitleTarget.value = data.subtitle
    }
    if (this.hasIsbn10Target && data.isbn_10) {
      this.isbn10Target.value = data.isbn_10
    }
    if (this.hasIsbn13Target && data.isbn_13) {
      this.isbn13Target.value = data.isbn_13
    }
    if (this.hasPublisherTarget && data.publisher) {
      this.publisherTarget.value = data.publisher
    }
    if (this.hasPublicationDateTarget && data.publication_date) {
      const year = this.parseYear(data.publication_date)
      if (year) {
        this.publicationDateTarget.value = year
      }
    }
    if (this.hasPageCountTarget && data.page_count) {
      this.pageCountTarget.value = data.page_count
    }
    if (this.hasLanguageTarget && data.language) {
      this.languageTarget.value = data.language
    }
    if (this.hasDescriptionTarget && data.description) {
      this.descriptionTarget.value = data.description
    }
    if (this.hasCoverImageUrlTarget && data.cover_image_url) {
      this.coverImageUrlTarget.value = data.cover_image_url
    }
    if (this.hasCoverThumbnailUrlTarget && data.cover_thumbnail_url) {
      this.coverThumbnailUrlTarget.value = data.cover_thumbnail_url
    }
  }

  parseYear(dateString) {
    if (!dateString) return null
    const str = String(dateString)

    const yearMatch = str.match(/(\d{4})/)
    return yearMatch ? yearMatch[1] : null
  }
}
